<template>
  <nav
    id="sidebar"
    class="bg-dark border-end border-4 border-primary text-light shadow d-flex flex-column flex-shrink-0"
    :class="sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-notcollapsed p-3'"
  >
    <router-link v-if="!sidebarCollapsed" :to="{ name: 'Dashboard' }" class="d-flex align-items-center mb-2 text-decoration-none text-light">
      <img src="@/assets/icons/1a_connect_white.png" class="me-3" width="72" />
      <span class="fs-4">ERP Admin</span>
    </router-link>

    <hr v-if="!sidebarCollapsed" />

    <ul v-if="!sidebarCollapsed" class="nav nav-pills flex-column mb-auto">
      <li class="nav-item mb-1">
        <router-link :to="{ name: 'Dashboard' }" class="nav-link w-100 d-flex px-1 rounded-0 text-white" exact-active-class="active">
          <div class="me-2 fa-lg" style="width: 30px"><font-awesome-icon icon="house" /></div>
          <span class="flex-fill text-start">Home</span>
        </router-link>
      </li>

      <li class="nav-item mb-1">
        <router-link :to="{ name: 'Unternehmen' }" class="nav-link w-100 d-flex px-1 rounded-0 text-white" exact-active-class="active">
          <div class="me-2 fa-lg" style="width: 30px"><font-awesome-icon icon="building" /></div>
          <span class="flex-fill text-start">Unternehmen</span>
        </router-link>
      </li>

      <li class="nav-item mb-1">
        <router-link :to="{ name: 'Benutzer' }" class="nav-link w-100 d-flex px-1 rounded-0 text-white" exact-active-class="active">
          <div class="me-2 fa-lg" style="width: 30px"><font-awesome-icon icon="users" /></div>
          <span class="flex-fill text-start">Benutzer</span>
        </router-link>
      </li>

      <li class="nav-item mb-1">
        <router-link :to="{ name: 'Applications' }" class="nav-link w-100 d-flex px-1 rounded-0 text-white" exact-active-class="active">
          <div class="me-2 fa-lg" style="width: 30px"><font-awesome-icon icon="display" /></div>
          <span class="flex-fill text-start">Applications</span>
        </router-link>
      </li>
    </ul>

    <hr v-if="!sidebarCollapsed" />
  </nav>
</template>

<script lang="ts" setup>
  //#region Imports
  import { ref } from 'vue';
  //#endregion

  const sidebarCollapsed = ref(false);
</script>

<style lang="scss" scoped>
  #sidebar {
    z-index: 1;
  }

  .active {
    background: #212529 !important;
    // color: #B5E655 !important;
    color: #0d6efd !important;
    // color: #fff !important;
  }

  .sidebar-notcollapsed {
    width: 300px;
    transition: width 0.3s ease-in-out;
  }
  .sidebar-collapsed {
    width: 15px;
    transition: width 0.3s ease-in-out;
  }

  .btn-toggle[aria-expanded='true']::after {
    transform: rotate(0deg);
  }

  .btn-toggle::after {
    width: 1.25em;
    margin: auto 0 auto 0;
    line-height: 0;
    transition: transform 0.35s ease;
    transform: rotate(-90deg);
    content: url(../assets/icons/chevron-down-white.svg);
  }
</style>
<!-- content: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e); -->
